import { SpinnerGap, Check } from '@phosphor-icons/react';
import { fmt } from './styles';

function DetailsRows({
  spSubtotal, spPortes, spIva, cartTotal,
  spValorDescontoCP, spDescontoVale, spDescontoCreditos, spDescontos,
}) {
  return (
    <div className="space-y-1 text-sm border-b border-[#E5E7EB] pb-3 mb-3">
      <div className="flex justify-between">
        <span className="text-[#6B7280]">SubTotal</span>
        <span>{spSubtotal != null ? fmt(spSubtotal) : fmt(cartTotal)}</span>
      </div>
      {spPortes != null && Number(spPortes) >= 0 && (
        <div className="flex justify-between"><span className="text-[#6B7280]">Portes</span><span>{fmt(spPortes)}</span></div>
      )}
      {spIva != null && (
        <div className="flex justify-between"><span className="text-[#6B7280]">IVA</span><span>{fmt(spIva)}</span></div>
      )}
      {Number(spValorDescontoCP) > 0 && (
        <div className="flex justify-between text-green-600"><span>- Código Promocional</span><span>{fmt(spValorDescontoCP)}</span></div>
      )}
      {Number(spDescontoVale) > 0 && (
        <div className="flex justify-between text-green-600"><span>- Vales</span><span>{fmt(spDescontoVale)}</span></div>
      )}
      {Number(spDescontoCreditos) > 0 && (
        <div className="flex justify-between text-green-600"><span>- Créditos</span><span>{fmt(spDescontoCreditos)}</span></div>
      )}
      {Number(spDescontos) > 0 && (
        <div className="flex justify-between text-green-600"><span>- Desconto</span><span>{fmt(spDescontos)}</span></div>
      )}
    </div>
  );
}

export default function TotalBox({
  showDetails, setShowDetails,
  spSubtotal, spPortes, spIva, cartTotal,
  spValorDescontoCP, spDescontoVale, spDescontoCreditos, spDescontos,
  spTotalPagar, verifying,
  confirming, onConfirm, isPhonePayment, mbwayPhone,
  selectedPayment, selectedTransport, selectedAddrEnvio,
  orderResult,
}) {
  const disabled = confirming
    || !selectedPayment
    || !selectedTransport
    || !selectedAddrEnvio
    || (isPhonePayment && !mbwayPhone.trim());
  return (
    <div className="bg-[#F9FAFB] rounded-xl p-5 border border-[#E5E7EB]" data-testid="total-box">
      <div className="text-center mb-1">
        <p className="text-xs text-[#6B7280] uppercase tracking-wide">Total</p>
      </div>
      <button onClick={() => setShowDetails(!showDetails)} data-testid="toggle-details"
        className="text-xs text-[#0F1829] font-medium hover:underline flex items-center gap-1 mx-auto mb-2">
        {showDetails ? 'Esconder Detalhes' : 'Mostrar Detalhes'}
      </button>
      {showDetails && (
        <DetailsRows
          spSubtotal={spSubtotal} spPortes={spPortes} spIva={spIva} cartTotal={cartTotal}
          spValorDescontoCP={spValorDescontoCP} spDescontoVale={spDescontoVale}
          spDescontoCreditos={spDescontoCreditos} spDescontos={spDescontos}
        />
      )}
      <div className="flex justify-between items-center mb-4">
        <span className="text-sm font-medium text-[#6B7280]">Valor a Pagar:</span>
        <span className="text-2xl font-bold text-[#111827]">
          {verifying ? <SpinnerGap size={20} className="animate-spin text-[#0F1829]" /> : fmt(spTotalPagar ?? cartTotal)}
        </span>
      </div>
      <button onClick={onConfirm} data-testid="confirm-order-btn" disabled={disabled}
        className="w-full py-3 bg-[#0F1829] text-white text-sm font-semibold rounded-lg hover:bg-[#001f6e] disabled:opacity-40 transition-colors flex items-center justify-center gap-2">
        {confirming ? <SpinnerGap size={16} className="animate-spin" /> : <Check size={16} />}
        Finalizar
      </button>
      {orderResult && !orderResult.success && (
        <p className="mt-3 text-sm text-red-600 font-medium text-center" data-testid="order-error">
          {orderResult.message}
        </p>
      )}
    </div>
  );
}
